import type { SelectedDefectNoticeProps } from "./SelectedDefectNotice.type";

import { CheckCircleTwoTone, WarningTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

// Warning message is displayed when an unsuggested defect (confidence level is too low) is selected by the user
const SelectedDefectNotice = ({
  name = "",
  confidence,
  suggested,
}: SelectedDefectNoticeProps) => {
  const { t } = useTranslation();

  return (
    <div className="selected-defect-notice">
      {suggested ? (
        <Tooltip
          placement="top"
          title={
            confidence
              ? `${Number((confidence * 100).toFixed(1))}% ${t(
                  "form:staticField.defectSuggestion.confidence"
                )}`
              : undefined
          }
        >
          <CheckCircleTwoTone
            className="check-circle-Two-tone"
            twoToneColor="#52c41a"
            data-testid="greenCheckCircle"
          />
        </Tooltip>
      ) : (
        <Tooltip
          placement="top"
          title={
            confidence
              ? `${name} ${t(
                  "form:staticField.defectSuggestion.warning"
                )} ${Number((confidence * 100).toFixed(1))}%`
              : undefined
          }
        >
          <WarningTwoTone
            className="warning-Two-tone"
            twoToneColor="#f29d41"
            data-testid="warning"
          />
        </Tooltip>
      )}
    </div>
  );
};

export default SelectedDefectNotice;
